"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_68_6933",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "2",
  width: "14",
  height: "12",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5469 2.5293c.528.432.6059 1.2102.1739 1.7383L7.309 13.3264a1.2354 1.2354 0 0 1-1.8296.0912L1.3618 9.3c-.4824-.4824-.4824-1.2646 0-1.747.4824-.4824 1.2646-.4824 1.747 0l3.1524 3.1525 6.5474-8.0024c.432-.528 1.2103-.6059 1.7383-.1738Z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_68_6933)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))], 'IconCheckBoldIcon', '1em', '1em', '#000001', '0 0 16 16');
SvgIcon.displayName = 'IconCheckBold';
var _default = SvgIcon;
exports["default"] = _default;